import { type GetCouponsCountRequestParams, getCouponCount } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type GetCouponsCountServiceResponse,
  GetCouponsCountServiceResponseSchema,
} from './getCouponCount.dto';

const transformApiResponseToServiceResponse = async ({
  shopTitle,
}: GetCouponsCountRequestParams): Promise<GetCouponsCountServiceResponse> => {
  const response = await getCouponCount({ shopTitle });

  return {
    totalCount: response.data.totalCount,
    availableCount: response.data.availableCount,
  };
};

export const getCouponCountService = withServiceErrorCapture(
  lazyPipe(
    transformApiResponseToServiceResponse,
    validateServiceResponse(GetCouponsCountServiceResponseSchema),
  ),
);
